var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg019Copy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m417.156 0h-252.623c-28.036 0-50.844 21.533-50.844 48v16h-34.944c-19.159 0-34.745 15.586-34.745 34.745v378.51c0 19.159 15.586 34.745 34.745 34.745h284.821c19.159 0 34.745-15.586 34.745-34.745v-29.255h18.845c28.035 0 50.844-21.533 50.844-48v-352c0-26.467-22.809-48-50.844-48zm-50.845 477.255c0 1.514-1.231 2.745-2.745 2.745h-284.821c-1.514 0-2.745-1.231-2.745-2.745v-378.51c0-1.514 1.231-2.745 2.745-2.745h284.821c1.514 0 2.745 1.231 2.745 2.745zm69.689-77.255c0 8.822-8.454 16-18.844 16h-18.845v-317.255c0-19.159-15.586-34.745-34.745-34.745h-217.877v-16c0-8.822 8.454-16 18.844-16h252.623c10.39 0 18.844 7.178 18.844 16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m300 216h-152c-8.836 0-16-7.164-16-16s7.164-16 16-16h152c8.836 0 16 7.164 16 16s-7.164 16-16 16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m300 280h-152c-8.836 0-16-7.164-16-16s7.164-16 16-16h152c8.836 0 16 7.164 16 16s-7.164 16-16 16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m300 344h-152c-8.836 0-16-7.164-16-16s7.164-16 16-16h152c8.836 0 16 7.164 16 16s-7.164 16-16 16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg019Copy);
export default __webpack_public_path__ + "static/media/019-copy.c2109f992c3bfded96b4e1c06b93a2c5.svg";
export { ForwardRef as ReactComponent };